import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";




export const fetchActiveUserRoles = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}accounts/roles/internal/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map(role => ({ label: role.name, value: role.id }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};